// extracted by mini-css-extract-plugin
export default {"customBox":"_customBoxButton_customBox__6u8D3","boxLabel":"_customBoxButton_boxLabel__BYI9a","boxImage":"_customBoxButton_boxImage__Ld8BG"};